import { render, staticRenderFns } from "./projectParticulars.vue?vue&type=template&id=b33a846e&scoped=true&"
import script from "./projectParticulars.vue?vue&type=script&lang=js&"
export * from "./projectParticulars.vue?vue&type=script&lang=js&"
import style0 from "./projectParticulars.vue?vue&type=style&index=0&id=b33a846e&lang=less&scoped=true&"
import style1 from "./projectParticulars.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b33a846e",
  null
  
)

export default component.exports